import React from 'react';
import './ProductCard.css';
import { RiShoppingBagLine, RiHeartLine, RiHeartFill } from 'react-icons/ri';
import translationMenu from '../../data/translationMenu';
import { usePublicSettings } from '../../context/PublicSettingsContext';
import ProductCardImage from './ProductCardImage';

const ProductCard = ({ item, currentLanguage, t, onPreview, onAddToCart, onToggleWishlist, isInWishlist }) => {
    const { formatPrice } = usePublicSettings();
    const wishlistIdentifier = item._id || item.id;
    const displayName = item.name?.[currentLanguage] || item.name?.en || '';
    const variants = Array.isArray(item.variants) ? item.variants : [];
    const defaultVariant = variants.find((v) => v.isAvailable) || variants[0];
    const displayPrice =
        defaultVariant?.price != null ? defaultVariant.price : item.price;

    return (
        <article className='product-card' onClick={() => onPreview(item)}>
            <div className="product-circle"></div>
            <div className='product-img-container'>
                <ProductCardImage
                    product={item}
                    productName={displayName}
                    alt={displayName}
                />
            </div>
            <div className='product-card-content'>
                <h3 className='product-title'>
                    {displayName}
                </h3>
                <p className='popular-description'>{translationMenu[currentLanguage]?.categories?.[item.category] || item.category}</p>

            </div>
            <div className='product-card-footer'>
                <span className='product-price'>{formatPrice(displayPrice)}</span>
                <div className='product-actions'>
                    <button
                        type="button"
                        className='product-button'
                        onClick={(e) => onAddToCart(item, e)}
                        title={t('menu.modal.addToCart')}
                    >
                        <RiShoppingBagLine />
                    </button>
                    <button
                        type="button"
                        className={`product-wishlist-button ${isInWishlist(wishlistIdentifier) ? 'active' : ''}`}
                        onClick={(e) => onToggleWishlist(item, e)}
                        title={t('menu.addToWishlist')}
                    >
                        {isInWishlist(wishlistIdentifier) ? <RiHeartFill /> : <RiHeartLine />}
                    </button>
                </div>
            </div>
        </article>
    );
};

export default ProductCard;
